import { combineSlices } from "@reduxjs/toolkit";
import proposalActivityReducer from "slices/proposalActivity";
import proposalDashboardReducer from "slices/proposalDashboard";
import archivedProposalsByReasonReducer from "slices/proposalDashboard/archivedProposalsByReason";
import proposalAssignmentReducer from "slices/proposalDashboard/proposalAssignment";
import proposalNotificationsWidgetReducer from "slices/proposalDashboard/proposalNotificationsWidget";
import proposalRecentActivityReducer from "slices/proposalDashboard/proposalRecentActivity";
import proposalSectionsAssignmentReducer from "slices/proposalDashboard/proposalSectionsAssignment";
import sectionStatusReducer from "slices/sectionStatus";
import { proposalDueDateTimeline, proposalTimeline } from "slices/timeline";
import totalValueByStageReducer from "slices/totalValueByStage";

import listSlice from "./list/proposalsListSlice";
import proposalSlice from "./proposal/proposalSlice";
import proposalsSlice from "./proposalsSlice";

const combined = combineSlices(
  proposalSlice,
  proposalsSlice,
  listSlice,
  proposalTimeline.slice,
  proposalDueDateTimeline.slice,
  {
    dashboardFilters: proposalDashboardReducer,
    activity: proposalActivityReducer,
    totalValueByStage: totalValueByStageReducer,
    sectionStatus: sectionStatusReducer,
    notificationsWidget: proposalNotificationsWidgetReducer,
    recentActivity: proposalRecentActivityReducer,
    proposalAssignment: proposalAssignmentReducer,
    sectionsAssignment: proposalSectionsAssignmentReducer,
    archivedProposalsByReason: archivedProposalsByReasonReducer,
  }
);

export default combined;
